import {
  FETCHED_HISTORY,
  REMOVE_WALLET,
  REMOVE_ASSET
} from '../actions/types';
import {differenceWith} from 'ramda';
import M from 'materialize-css/dist/js/materialize.min.js'

let initialState =  {
  nrg: [],
  emb: [],
  btc: [],
  eth: [],
  neo: [],
  wav: [],
  dai: [],
  usdt:[],
  'l-emb':[],
  lsk: []
}

export default function(state: Object = initialState, action) {
  switch(action.type) {
    case FETCHED_HISTORY:
      let newstate = state;
      let oldHistory = newstate[action.payload.type]
      if(oldHistory.length != 0 && action.payload.history.length != oldHistory.length){
        const cmp = (x,y) => x.txHash == y.txHash;
        let newTxs = differenceWith(cmp,action.payload.history,oldHistory)
        for(let tx of newTxs){
          if(tx.from !== 'Mined' && (tx.from != tx.to) && tx.to != 'Maker' && tx.to != "Taker"){
            let text = tx.color === `rgb(101, 173, 97)` ? 'Recieved' : 'Sent';
            let color = tx.color === `rgb(101, 173, 97)` ? 'green' : 'red';
            // M.toast({html: `${tx.value} ${action.payload.type.toUpperCase()} ${text}`,classes: color,displayLength:3000});
          }
        }
      }
      newstate[action.payload.type] = action.payload.history
      return {...newstate}
    case REMOVE_ASSET:
      newstate = state;
      newstate[action.payload] = []
      return {...newstate}
    case REMOVE_WALLET:
      return {
        nrg: [],
        emb: [],
        btc: [],
        eth: [],
        neo: [],
        usdt: [],
        dai: [],
        wav: [],
        lsk: []}
    default:
      return state;
  }
}
